import useApiMutation from '@src/hooks/useApiMutation';
import { Stack, StackEdited } from '@src/types/Stacks';

export default (id?: string | null, isDefault?: boolean) => {
  const cmtPath = isDefault ? '/default-stack' : `/stacks/${id ? `${id}` : ''}`;

  const createStack = useApiMutation<StackEdited, Stack>({
    apiPath: cmtPath,
    method: 'POST',
    useV2API: true,
  });

  const updateStack = useApiMutation<StackEdited, Stack>({
    apiPath: cmtPath,
    method: 'PATCH',
    useV2API: true,
  });

  const deleteStack = useApiMutation({
    apiPath: cmtPath,
    method: 'DELETE',
    useV2API: true,
  });

  return {
    createStack,
    updateStack,
    deleteStack,
  };
};
